import es from "./translations/es.json";
import en from "./translations/en.json";
import ca from "./translations/ca.json";
import it from "./translations/it.json";
export default {
	en,
	es,
	ca,
	it
};
